export default __webpack_public_path__ + "static/okr-hero-51b47e9ee540df835c984e5cef3474cd.mp4";